import {
  Component,
  forwardRef,
} from '@angular/core';
import {
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { ClientWrapperComponent } from '@app/pages/quote/standard-quote/client/client-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-client-mobile',
  templateUrl: './client-mobile.component.html',
  styleUrls: ['./client-mobile.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ClientMobileComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ClientMobileComponent),
      multi: true,
    },
  ],
})
export class ClientMobileComponent  extends ClientWrapperComponent
{
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}

